AuthRoute = require 'mixins/authenticated-route'
{ STATUSES } = require 'models/order'

###
# Карточка клиента
###
App.ClientsClientRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    @store.fetchById('client', params.client_id)

  afterModel: (model) ->
    Em.RSVP.hash(
      initialClientTags : model.get('client_tags').toArray()
    ).then (attrs) =>
      controller = @controllerFor('clients.client')
      controller.setProperties(attrs)


